import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
} from '../utils/event_constants';

export const amazonTextractActions = [
  {
    name: 'amazonTextract',
    label: 'Amazon Textract',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForDocument', label: 'Select Document Field' }),
      collectionFieldArgsConfig({ name: 'fieldForText', label: 'Select Text Field' }),
      ...alertMessagesArgsConfig,
    ],
  },
];
